import { gql } from '@apollo/client';
import { TermFragment } from '../fragments/TermFragment';
/**
 * @const TermesQuery
 * @since 1.0.0
 */
export const TermsQuery = gql `
  query TermesQuery($input: TermsInput) {
    terms(input: $input) {
      items {
        ...TermFragment
      }
      count
    }
  }

  ${TermFragment}
`;
